/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { PhoneCall } from '@zcode-ui/icons'
import type { Origin } from '@zcode/nr-utils'
import type { Listable } from '@zcode/state-type'
import cn from 'classnames'
import React, { type MouseEvent, useCallback } from 'react'
import css from './ListingCardCallButton.module.scss'
import buttonCss from './buttons.module.scss'

export type OnPaidPhoneClick = (params: {
  entity: Listable
  mixpanelOrigin: Origin
}) => (e: MouseEvent<HTMLAnchorElement>) => void

interface CallButtonProps {
  entity: Listable
  onPaidPhoneClick: OnPaidPhoneClick
  origin: Origin
  paidPhoneHref: string
}

export const ListingCardCallButton = ({
  entity,
  onPaidPhoneClick,
  origin,
  paidPhoneHref,
}: CallButtonProps) => {
  const onClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation()
      onPaidPhoneClick({
        entity,
        mixpanelOrigin: origin,
      })(e)
    },
    [entity, onPaidPhoneClick, origin]
  )

  return (
    <a
      href={paidPhoneHref}
      onClick={onClick}
      className={cn(buttonCss.mdButton, buttonCss.linkButton, css.callBtn)}
    >
      <PhoneCall />
      <p>Call</p>
    </a>
  )
}
